const BANKING_FINANCE_SEGMENTS = [
    'Banking & Finance',
    'Banking & Lending',
    'Banks & Lenders',
    'Mortgage & Financial Services',
    'Mortgage Brokers',
];

const INDUSTRY_SEGMENTS = {
    BANKING_FINANCE: 'Banking & Finance',
};

export const isBankingAndFinanceSegment = (segment) =>
    BANKING_FINANCE_SEGMENTS.includes(segment);

export default INDUSTRY_SEGMENTS;
